export const SurveyIcon = ({ ...props }) => {
  return (
    <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <path d="m7.5 7.25c0 .41421-.33579.75-.75.75s-.75-.33579-.75-.75.33579-.75.75-.75.75.33579.75.75z" />
        <path d="m6.75 11c.41421 0 .75-.3358.75-.75 0-.41421-.33579-.75-.75-.75s-.75.33579-.75.75c0 .4142.33579.75.75.75z" />
        <path d="m7.5 13.25c0 .4142-.33579.75-.75.75s-.75-.3358-.75-.75.33579-.75.75-.75.75.3358.75.75z" />
        <path d="m9.5 7c-.27614 0-.5.22386-.5.5s.22386.5.5.5h4c.2761 0 .5-.22386.5-.5s-.2239-.5-.5-.5z" />
        <path d="m9 10.5c0-.2761.22386-.5.5-.5h4c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-4c-.27614 0-.5-.2239-.5-.5z" />
        <path d="m9.5 13c-.27614 0-.5.2239-.5.5s.22386.5.5.5h4c.2761 0 .5-.2239.5-.5s-.2239-.5-.5-.5z" />
        <path d="m3 5c0-1.10457.89543-2 2-2h10c1.1046 0 2 .89543 2 2v10c0 1.1046-.8954 2-2 2h-10c-1.10457 0-2-.8954-2-2zm2-1c-.55228 0-1 .44772-1 1v10c0 .5523.44772 1 1 1h10c.5523 0 1-.4477 1-1v-10c0-.55228-.4477-1-1-1z" />
      </g>
    </svg>
  );
};
